import React from 'react';
import { Link } from 'react-router-dom';
import { Gift, ShieldCheck, HeartHandshake } from 'lucide-react';
import { ABOUT, ABOUT_FR, IMAGES } from '../data/mock';

const ICONS = [Gift, ShieldCheck, HeartHandshake];

export default function About({ lang = 'en' }) {
  const fr = lang === 'fr';
  const ABOUT_DATA = fr ? ABOUT_FR : ABOUT;
  return (
    <div className="max-w-[1000px] mx-auto px-5 py-12" data-testid={`about-page-${lang}`}>
      <h1 className="font-hand text-[40px] text-center text-slate-900 fade-up">{ABOUT_DATA.title}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mt-8">
        <div className="prose-site">
          {ABOUT_DATA.paragraphs.map((p) => <p key={p}>{p}</p>)}
          <Link to={fr ? '/fr/contact' : '/contact-us'} className="btn-gold !no-underline inline-block !text-white mt-2" data-testid="about-contact-btn">{fr ? 'Nous contacter' : 'Get in touch'}</Link>
        </div>
        <img src={IMAGES.pen} alt={fr ? 'Stylo plume de calligraphie' : 'Calligraphy pen'} className="rounded-xl shadow-xl w-full h-[320px] object-cover" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-14">
        {ABOUT_DATA.values.map((v, i) => {
          const Icon = ICONS[i];
          return (
            <div key={v.title} className="bg-[var(--brand-soft)] border border-[var(--line)] rounded-lg p-6 transition-transform duration-300 hover:-translate-y-1">
              <Icon className="w-7 h-7 text-[var(--brand)] mb-3" />
              <h3 className="text-[18px] font-bold text-[var(--ink)]">{v.title}</h3>
              <p className="text-[14.5px] text-slate-600 mt-1">{v.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
